import endpoints from 'endpoints';
import {
  API_REQUEST_START,
  API_REQUEST_END,
  API_REQUEST_CANCELLED,
} from 'actionTypes';

// Want to have an object where each of our endpoints is just false, to signify
// that it is not being fetched.
const initialEndpointState = { isFetching: false, count: 0 };
let initialState = {};
Object.keys(endpoints).forEach(
  key => (initialState[key] = initialEndpointState)
);

export default function reducer(state = initialState, action) {
  let { type, apiAction } = action;
  switch (type) {
    case API_REQUEST_START:
      return {
        ...state,
        [apiAction]: {
          isFetching: true,
          count: (state[apiAction].count || 0) + 1,
        },
      };
    case API_REQUEST_CANCELLED:
    case API_REQUEST_END:
      const count = Math.max(state[apiAction].count - 1, 0);
      return {
        ...state,
        [apiAction]: {
          isFetching: count !== 0,
          count,
        },
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/loadingStateReducer.js